import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "en-button-overlay",
    "aria-hidden": "true"
};
const _hoisted_2 = {
    key: 0,
    class: "en-button-spinner"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["aria-hidden"];
const _hoisted_5 = {
    key: 0,
    class: "en-button-prepend"
};
const _hoisted_6 = {
    key: 1,
    class: "en-button-append"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnTooltip"], {
        text: $props.tooltip ?? undefined,
        position: $props.tooltipLocation,
        "static-id": $setup.tooltipStaticId
    }, {
        default: _withCtx(() => [
            _createVNode($setup["Button"], _mergeProps($setup.forwardedAttrs, {
                id: $setup.buildId(),
                variant: $setup.resolvedVariant,
                size: $setup.resolvedSize,
                type: $props.nativeType,
                disabled: $setup.disabledComputed,
                class: $setup.buttonClass,
                style: $setup.buttonStyle,
                "aria-busy": $setup.isLoading ? 'true' : undefined,
                onClick: $setup.onClick
            }), {
                default: _withCtx(() => [
                    ($setup.isLoading || $setup.showFeedback)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["feedback-wrapper", { 'icon-only': $props.feedbackIconOnly || (!$setup.hasCustomFeedbackSlot && !$setup.showFeedbackText) }])
                                }, [
                                    ($setup.hasCustomFeedbackSlot)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            ($setup.isSuccess)
                                                ? _renderSlot(_ctx.$slots, "success", {}, undefined, true, 0)
                                                : ($setup.isError)
                                                    ? _renderSlot(_ctx.$slots, "error", {}, undefined, true, 1)
                                                    : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            ($setup.feedbackIcon)
                                                ? (_openBlock(), _createBlock($setup["EnIcon"], {
                                                    key: 0,
                                                    class: _normalizeClass($setup.feedbackIcon)
                                                }, null, 8 /* PROPS */, ["class"]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.showFeedbackText)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.feedbackMessage), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                ], 2 /* CLASS */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(["en-button-body", { 'invisible-preserve': $setup.isLoading || $setup.showFeedback }]),
                        "aria-hidden": $setup.isLoading || $setup.showFeedback ? 'true' : 'false'
                    }, [
                        (_ctx.$slots.icon || $props.icon)
                            ? _renderSlot(_ctx.$slots, "icon", {}, () => [
                                ($props.icon)
                                    ? (_openBlock(), _createBlock($setup["EnIcon"], { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($props.icon), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ], true, 0)
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.$slots.prepend || $props.prependIcon)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _renderSlot(_ctx.$slots, "prepend", {}, () => [
                                            ($props.prependIcon)
                                                ? (_openBlock(), _createBlock($setup["EnIcon"], { key: 0 }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($props.prependIcon), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }))
                                                : _createCommentVNode("v-if", true)
                                        ], true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                                (_ctx.$slots.append || $props.appendIcon)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                        _renderSlot(_ctx.$slots, "append", {}, () => [
                                            ($props.appendIcon)
                                                ? (_openBlock(), _createBlock($setup["EnIcon"], { key: 0 }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($props.appendIcon), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }))
                                                : _createCommentVNode("v-if", true)
                                        ], true)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                    ], 10 /* CLASS, PROPS */, _hoisted_4)
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["id", "variant", "size", "type", "disabled", "class", "style", "aria-busy"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["text", "position", "static-id"]));
}
